/*
  pdp-mobile-order.js
  ───────────────────
  Figma mobile flow places the Tilbehør/Reservedele band INSIDE the buy
  box, after the tax note and before the trust items — on desktop it is
  a full-width band below the hero grid (and must stay outside that
  grid, or the sticky gallery slides under it). Same DOM node, relocated
  per breakpoint; the carousel element guards against re-init on move.
*/
(function () {
  if (window.__ggmPdpMobileOrder) return;
  window.__ggmPdpMobileOrder = true;

  var mq = window.matchMedia('(max-width: 1024px)');

  function directChildOf(wrapper, el) {
    while (el && el.parentElement && el.parentElement !== wrapper) {
      el = el.parentElement;
    }
    return el && el.parentElement === wrapper ? el : null;
  }

  function place() {
    var band = document.querySelector('.pm__upsell-band');
    if (!band) return;

    /* Historically, global.js also relocated .shopify-block.pm__upsell
       (before the SEO dropdown, the OLD design's mobile placement) at
       DOMContentLoaded — competing with this script for the same element
       and causing a real, measured CLS race condition. That dead handler
       has since been removed from global.js, so this reclaim is now a
       harmless no-op in the common case; left in as a cheap defensive
       check in case anything else ever moves this element again. */
    var block = document.querySelector('.shopify-block.pm__upsell');
    if (block && block.parentElement !== band) {
      band.appendChild(block);
    }

    if (mq.matches) {
      var wrapper = document.querySelector('.pm__information-wrapper');
      if (!wrapper) return;
      var target =
        wrapper.querySelector('.pm__trust-item') ||
        wrapper.querySelector('.pm__downloads') ||
        wrapper.querySelector('.shipping-info');
      if (!target) {
        if (band.parentElement !== wrapper) wrapper.appendChild(band);
        return;
      }
      var anchor = directChildOf(wrapper, target);
      if (!anchor) return;
      /* shipping-info fallback anchors ABOVE the band, not below */
      var before = target.classList.contains('shipping-info') ? anchor.nextElementSibling : anchor;
      if (band.nextElementSibling !== before || band.parentElement !== wrapper) {
        wrapper.insertBefore(band, before);
      }
    } else {
      var hero = document.querySelector('.pm__content-wrapper');
      if (hero && hero.parentNode && hero.nextElementSibling !== band) {
        hero.parentNode.insertBefore(band, hero.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  /* CWV: this used to guard against global.js's own (older) mobile
     relocation of the same .shopify-block.pm__upsell, which could fire
     AFTER the call above and undo it until the window.load retry far
     below — several seconds on mobile, and a real, measured layout shift
     (GSC field data: CLS >0.25 on roughly half of mobile PDPs). That
     competing handler has since been removed from global.js entirely, so
     there is no other script left to race — the CLS issue is fixed at
     the root, not just re-timed around. Kept as a harmless extra run
     (cheap, place() no-ops if nothing needs to move) rather than removed,
     since it costs nothing and adds a small margin of safety. */
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(place, 0);
  });

  window.addEventListener('load', place);

  if (mq.addEventListener) {
    mq.addEventListener('change', place);
  } else if (mq.addListener) {
    mq.addListener(place);
  }
})();
